import { formatProductType } from "@/lib/formatProductType";

import { leafLabel } from "./kindWords";
import { pathLabel } from "./pathLabel";

type TargetRow = {
  path?: unknown;
  linkOwner?: unknown;
  linkField?: unknown;
};

export function pickTarget(
  row: TargetRow,
  pickedPath: string | null,
  pickedLeaf: string | null,
  labelOf: (path: string) => string,
) {
  const stored = pickedPath ? labelOf(pickedPath) : null;
  const linkName =
    (!pickedPath || pickedPath === row.path) && row.linkField
      ? String(row.linkField)
      : null;
  const pickLabel =
    stored && stored !== pickedPath
      ? stored
      : (linkName ??
        (pickedPath
          ? pathLabel(labelOf, pickedPath)
          : leafLabel(pickedLeaf ?? "")));
  const toName = row.linkOwner
    ? `${formatProductType(String(row.linkOwner))} “${pickLabel}”`
    : `“${pickLabel}”`;
  return { pickLabel, toName };
}
